/**
 * Maps a dock icon's app id to related OS `appId` values for the OS dock.
 *
 * Used for: open indicator, context menu, Show all windows, Hide, and Quit.
 *
 * - **Workers**: directory (`workers`) and per-worker (`worker`) windows are one family.
 * - **Documents**: library (`documents`) and single-doc (`document`) windows are one family.
 * - **Reports** (`reports`) and **Report Builder** (`report-builder`) are never grouped; each
 *   icon only reflects and controls its own windows.
 *
 * Scenario Tracker has a separate product-focus family. Keep that list out of
 * `getRelatedAppIdsForOsDock` so context menu actions like Hide/Quit stay scoped
 * to the specific dock app the user clicked.
 */
export const SCENARIO_TRACKER_DOCK_APP_IDS: readonly string[] = [
  "scenario-tracker",
  "scenario-tracker-newsflow",
  "scenario-tracker-directionality",
  "scenario-tracker-heatmap",
  "scenario-tracker-deep-dive",
  "scenario-tracker-metric-projections",
  "scenario-metric-detail",
  "scenario-article-detail",
];

export function isScenarioTrackerDockApp(appId: string): boolean {
  return SCENARIO_TRACKER_DOCK_APP_IDS.includes(appId);
}

/**
 * @param appId - Dock / primary app id.
 * @returns Distinct app ids whose windows belong to that dock icon.
 */
export function getRelatedAppIdsForOsDock(appId: string): string[] {
  if (appId === "workers") return ["workers", "worker"];
  if (appId === "documents") return ["documents", "document"];
  return [appId];
}
